import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Outlet } from 'react-router-dom';

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary.tsx';
import { ToolkitGenericFallback } from '../../components/ToolkitGenericFallback.tsx';
import { useFeatureClientReadyState } from '../../featureDecisions/index.ts';
import { whatEnv } from '../../utils/whatEnv.ts';
import { FTUXContextProvider } from '../FTUXContextProvider.tsx';
import { ModuleContextProvider } from '../ModuleContextProvider.tsx';

export const RootRouteElement = () => {
  const isLocal = whatEnv() === 'local';

  const isFeatureClientReady = useFeatureClientReadyState();
  if (!isFeatureClientReady) return null;

  return (
    <ModuleContextProvider expectOrder={false}>
      <FTUXContextProvider>
        <ErrorBoundary Fallback={ToolkitGenericFallback}>
          <Outlet />
        </ErrorBoundary>
        {isLocal && (
          <ReactQueryDevtools
            initialIsOpen={false}
            position="bottom"
            buttonPosition="bottom-left"
          />
        )}
      </FTUXContextProvider>
    </ModuleContextProvider>
  );
};
